import { computed, useRoute } from "@nuxtjs/composition-api";
function usePaginationData(meta) {
  const route = useRoute();
  const currentPage = computed(() => route.value.query.page || 1);
  const totalPagesCount = computed(() => meta.value.last_page);
  return {
    currentPage,
    totalPagesCount
  };
}
;
export {
  usePaginationData as default
};
